<template>
  <div>
    <profileTabs />
    <router-view />
  </div>
</template>
<script>
import Profile from '@/views/logics/profile/Profile'
import profileTabs from './profileTabs.vue'

export default {
  components: {
    profileTabs,
  },
  mixins: [Profile],
}
</script>
